
// 批量设置公开画面
Vue.component("offline_list_modal", {
  props: {
      list: {
          type: Array,
          default: []
      }
  },
  computed: {
    listFormat(){
        return this.list.map(item => {
            return {
                ...item,
                value: item.value.replaceAll(';', '\n')
            }
        })
    }    
  },
  data() {
      return {
          visible: false,
      };
  },
  template: `
       <el-popover
          placement="left-start"
          width="460"
          popper-class="offline_list_modal"
          trigger="hover">
          <div class="offline_list_modal_header"><iconfont width="1.4em" height="1.4em" type="iconqingdan"></iconfont>{{$t('线下课程信息')}}</div>
          <div class="offline_list">
              <div class="offline_item" v-for="(item,i) in listFormat" :key="i">
                  <div class="label">{{item.label}}：</div><div class="value">{{item.value}}</div>
              </div>
          </div>
          <template slot="reference"><slot></slot></template>
       </el-popover>
  `,
});